// TODO: delete
import Button from '../modules/components/Button';

export default Button;
